// @flow weak

import { appConfig } from '../../config';
import {
  jsonHeaderAuth,
  refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
export const getAllTicket = async () => {
  const url = `${appConfig.BASE_API}/ticket/readall`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getProgressTicket = async (req) => {
  const url = `${appConfig.BASE_API}/ticket/progress`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};
export const getProgressTicketGCS = async (req) => {
  const url = `${appConfig.BASE_API}/ticketgcs/progress`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const updateTicket = async (req) => {
  const url = `${appConfig.BASE_API}/ticket/update`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const updateTicketLoopEDS = async (req) => {
  const url = `${appConfig.BASE_API}/ticket/updateloop`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const updateTicketGCS = async (req) => {
  const url = `${appConfig.BASE_API}/ticketgcs/update`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const updateTicketLoopGCS = async (req) => {
  const url = `${appConfig.BASE_API}/ticketgcs/updateloop`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const getTicketById = async (ticket_id) => {
  const url = `${appConfig.BASE_API}/ticket/readbyid/${ticket_id}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};
export const getTicketGCSById = async (ticket_id) => {
  const url = `${appConfig.BASE_API}/ticketgcs/readbyid/${ticket_id}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};
export const getTicketByCn = async (serial_number) => {
  const url = `${appConfig.BASE_API}/ticket/readbycn/${serial_number}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getTicketByCnGCS = async (serial_number) => {
  const url = `${appConfig.BASE_API}/ticketgcs/readbycn/${serial_number}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getTicketByDateFlag = async (req) => {
  const url = `${appConfig.BASE_API}/ticket/readbyflag`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getTicketGCSByDateFlag = async (req) => {
  const url = `${appConfig.BASE_API}/ticketgcs/readbyflag`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getTicketReportingByDateFlag = async (req) => {
  const url = `${appConfig.BASE_API}/ticketReporting/readbyflag`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getTicketReportingGCSByDateFlag = async (req) => {
  const url = `${appConfig.BASE_API}/ticketgcsReporting/readbyflag`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getUserAgent = async () => {
  const url = `${appConfig.BASE_API}/ticket/useragent`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getHistoryThreeMonth = async (serial_number) => {
  const url = `${appConfig.BASE_API}/Chart/${serial_number}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getHistoryThreeMonthGCS = async (serial_number) => {
  const url = `${appConfig.BASE_API}/Chartgcs/${serial_number}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getChartStatusToner = async (req) => {
  const url = `${appConfig.BASE_API}/chart/tonerstatus`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getChartStatusTonerGCS = async (req) => {
  const url = `${appConfig.BASE_API}/chartgcs/tonerstatus`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const sendToAdisa = async (req) => {
  const url = `${appConfig.BASE_API}/sendadisa`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const getResultAdisa = async (req) => {
  const url = `${appConfig.BASE_API}/adisagetresult`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};


export const getTicketAdisa = async () => {
  const url = `${appConfig.BASE_API}/ticket/getadisa`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getSlaToday = async () => {
  const url = `${appConfig.BASE_API}/ticket/getSlaToday_view`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const newTicketUnion = async () => {
  const url = `${appConfig.BASE_API}/ticket/newTicketUnion`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const newTicketUnionReadyReserved = async () => {
  const url = `${appConfig.BASE_API}/ticket/newTicketUnionReadyReserved`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const data_timeToSla = async () => {
  const url = `${appConfig.BASE_API}/ticket/data_timeToSla`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const searchCloseTicket = async (req) => {
  const url = `${appConfig.BASE_API}/ticket/searchCloseTicket`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
    .catch (error=> {
    return null;
  })
  return result
};

export const closeTicket = async (req) => {
  const url = `${appConfig.BASE_API}/ticket/close`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
      return res
    })    
   .catch (error=> {
    return false;
  })
  return result
};